import { AngularDataContext } from "@themost/angular";
import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import { BsModalService, BsModalRef } from "ngx-bootstrap";

@Component({
  selector: 'app-grading-schemes',
  templateUrl: './grading-schemes.component.html',
  styles: [
    `
    p {
      margin-bottom: 0.25rem;
    }
    `
  ],
  encapsulation: ViewEncapsulation.None
})
export class GradingSchemesComponent implements OnInit {

  public items: Array<any>;

  ngOnInit(): void {
    this._context.model('Institutes').where('partner').equal(true).getItems().then((institutes) => {
      this.items = institutes;
    });
  }
  constructor(private _context: AngularDataContext, private _modalRef: BsModalRef) {

  }

  close() {
    this._modalRef.hide();
  }

}
